export const HOTEL = 'HOTEL';
export const THC = 'THC';
export const FHR = 'FHR';
export const CITY = 'CITY';
export const RECENT_SEARCHES = 'RECENTSEARCHES';
